import { render } from "./App.vue?vue&type=template&id=86ad9cca"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=86ad9cca&lang=css"

import exportComponent from "/home/runner/work/frontend-webapp/frontend-webapp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__